import { LicenseCodename } from '../main/constants/LicenseCodename';
import { Subscription } from './Subscription';
import { INotificationsPayload } from './User';
import { DowngradeDetails } from './DowngradeDetails';
import { ICancellationDetails } from './CancellationDetails';

export class Notifications {
    private readonly _isActive: boolean;
    private readonly _isTrial: boolean;
    private readonly _accountDisabled?: boolean;
    private readonly _inVerification?: boolean;
    private readonly _paymentRefused?: boolean;
    private readonly _lastPaymentFailed?: boolean;
    private readonly _isDeveloper?: boolean;
    private readonly _trialExpiresAt?: string;
    private readonly _updateEmail?: string;
    private readonly _nextSubscription?: string;
    private readonly _downgradeSubscription?: Subscription;
    private readonly _desiredLicense?: string;
    private readonly _desiredLicensePeriod?: string;
    private readonly _remainingChargeAttempts?: number;
    private readonly _hasPendingMethodChange?: boolean;
    private readonly _pendingDowngradeDetails?: DowngradeDetails;
    private readonly _pendingCancellationDetails?: ICancellationDetails;
    private readonly _needsWelcome: boolean;

    constructor(notifications: INotificationsPayload, codename: LicenseCodename) {
        this._isActive = notifications.isActive;
        this._isTrial = notifications.isTrial;
        this._accountDisabled = notifications.accountDisabled;
        this._inVerification = notifications.inVerification;
        this._paymentRefused = notifications.paymentRefused;
        this._lastPaymentFailed = notifications.lastPaymentFailed;
        this._isDeveloper = codename === LicenseCodename.developer;
        this._trialExpiresAt = notifications.trialExpiresAt;
        this._updateEmail = notifications.updateEmail;
        this._nextSubscription = notifications.nextSubscription;
        this._desiredLicense = notifications.desiredLicense;
        this._desiredLicensePeriod = notifications.desiredLicensePeriod;
        this._remainingChargeAttempts = notifications.remainingChargeAttempts;
        this._downgradeSubscription = notifications.downgradeSubscription
            ? new Subscription(notifications.downgradeSubscription)
            : undefined;
        this._hasPendingMethodChange = notifications.hasPendingMethodChange;
        this._pendingDowngradeDetails = notifications?.pendingDowngradeDetails
            ? new DowngradeDetails(notifications?.pendingDowngradeDetails)
            : undefined;
        const pendingCancellationDetailsPayload = notifications?.pendingCancellationDetails;
        this._pendingCancellationDetails = pendingCancellationDetailsPayload
            ? { cancellationScheduledFor: pendingCancellationDetailsPayload.cancellationScheduledFor }
            : undefined;
        this._needsWelcome = notifications.needsWelcome;
    }

    public get isActive(): boolean {
        return this._isActive;
    }
    public get isTrial(): boolean {
        return this._isTrial;
    }

    public get accountDisabled(): boolean | undefined {
        return this._accountDisabled;
    }

    public get paymentRefused(): boolean | undefined {
        return this._paymentRefused;
    }

    public get inVerification(): boolean | undefined {
        return this._inVerification;
    }

    public get lastPaymentFailed(): boolean | undefined {
        return this._lastPaymentFailed;
    }

    public get isDeveloper(): boolean | undefined {
        return this._isDeveloper;
    }

    public get trialExpiresAt(): string | undefined {
        return this._trialExpiresAt;
    }

    get pendingDowngradeDetails(): DowngradeDetails | undefined {
        return this._pendingDowngradeDetails;
    }

    public get updateEmail(): string | undefined {
        return this._updateEmail;
    }

    public get nextSubscription(): string | undefined {
        return this._nextSubscription;
    }

    public get downgradeSubscription(): Subscription | undefined {
        return this._downgradeSubscription;
    }

    public get desiredLicense(): string | undefined {
        return this._desiredLicense;
    }

    public get desiredLicensePeriod(): string | undefined {
        return this._desiredLicensePeriod;
    }

    public get remainingChargeAttempts(): number | undefined {
        return this._remainingChargeAttempts;
    }

    get hasPendingMethodChange(): boolean | undefined {
        return this._hasPendingMethodChange;
    }

    public get pendingCancellationDetails(): ICancellationDetails | undefined {
        return this._pendingCancellationDetails;
    }

    public get needsWelcome(): boolean {
        return this._needsWelcome;
    }
}
